import * as React from "react";
import styled from "@mui/material/styles/styled";
import { DiseaseCategoryType } from "fe-common/graphql";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { Button, Theme } from "@mui/material";

//region [[ Styles ]]

const PlanTabsView = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  height: "60px",
  overflow: "hidden",
  borderTopLeftRadius: "25px",
  borderTopRightRadius: "25px",
  cursor: "pointer",
}));

const PlanButtons = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  marginBottom: "20px",
  marginLeft: "10px",
}));

const TabButton = styled(Button)(
  ({ theme, selected }: { theme?: Theme; selected: boolean }) => ({
    height: "20px",
    marginRight: "10px",
    padding: "15px 2px 15px 2px",

    minWidth: "unset",
    textTransform: "capitalize",

    borderRadius: "0px",
    color: selected === true ? KahunColorMap.Primary : "black",

    borderBottom:
      selected === true ? "3px solid " + KahunColorMap.Primary : "unset",
  }),
);

const Tab = styled("div")(
  ({ selected, embedded }: { selected: boolean; embedded: boolean }) => ({
    width: embedded ? "auto" : "50%",
    marginLeft: embedded ? "20px" : "0px",
    fontWeight: embedded && selected ? 600 : "inherit",
    display: "flex",

    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
  }),
);

const LeftFrontTab = styled("div")(({ selected }: { selected: boolean }) => ({
  borderTopRightRadius: selected ? "25px" : "0px",
  borderBottomRightRadius: selected ? "0px" : "25px",
  backgroundColor: selected
    ? KahunColorMap.AccentLight
    : KahunColorMap.AccentLight2,
  position: "absolute",
  width: "100%",
  height: "100%",
}));

const LeftBackTab = styled("div")(({ selected }: { selected: boolean }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: !selected
    ? KahunColorMap.AccentLight
    : KahunColorMap.AccentLight2,
}));

const RightFrontTab = styled("div")(({ selected }: { selected: boolean }) => ({
  borderTopLeftRadius: selected ? "25px" : "0px",
  borderBottomLeftRadius: selected ? "0px" : "25px",
  backgroundColor: selected
    ? KahunColorMap.AccentLight
    : KahunColorMap.AccentLight2,
  position: "absolute",
  width: "100%",
  height: "100%",
}));

const RightBackTab = styled("div")(({ selected }: { selected: boolean }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: !selected
    ? KahunColorMap.AccentLight
    : KahunColorMap.AccentLight2,
}));

const TabLabel = styled("div")(({ theme }) => ({
  fontSize: "17px",
  color: KahunColorMap.DefaultLight,
  fontWeight: 500,
  zIndex: 99,
  textTransform: "uppercase",
}));

const LeftTab = styled(Tab)(({ selected }: { selected: boolean }) => ({
  borderTopRightRadius: selected ? "25px" : "0px",
  borderTopLeftRadius: selected ? "25px" : "0px",

  borderBottomRightRadius: selected ? "0px" : "25px",
  borderBottomLeftRadius: selected ? "0px" : "25px",
}));

const RightTab = styled(Tab)(({ selected }: { selected: boolean }) => ({
  borderTopRightRadius: selected ? "25px" : "0px",
  borderTopLeftRadius: selected ? "25px" : "0px",

  borderBottomRightRadius: selected ? "0px" : "25px",
  borderBottomLeftRadius: selected ? "0px" : "25px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PlanTabsProps {
  labsClicked: () => void;
  imagingClicked: () => void;
  selected: DiseaseCategoryType;
  isEmbedded?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PlanTabs = ({ ...props }: PlanTabsProps) => {
  return (
    <>
      {!props.isEmbedded && (
        <PlanTabsView>
          <LeftTab
            selected={props.selected === DiseaseCategoryType.OutcomeTest}
            embedded={props.isEmbedded}
            onClick={props.labsClicked}
          >
            <TabLabel>Labs</TabLabel>

            {!props.isEmbedded && (
              <>
                <LeftBackTab
                  selected={props.selected === DiseaseCategoryType.OutcomeTest}
                />
                <LeftFrontTab
                  selected={props.selected === DiseaseCategoryType.OutcomeTest}
                />
              </>
            )}
          </LeftTab>
          <RightTab
            selected={props.selected === DiseaseCategoryType.Imaging}
            onClick={props.imagingClicked}
            embedded={props.isEmbedded}
          >
            <TabLabel>Imaging</TabLabel>
            {!props.isEmbedded && (
              <>
                <RightBackTab
                  selected={props.selected === DiseaseCategoryType.Imaging}
                />
                <RightFrontTab
                  selected={props.selected === DiseaseCategoryType.Imaging}
                />
              </>
            )}
          </RightTab>
        </PlanTabsView>
      )}

      {props.isEmbedded && (
        <PlanButtons>
          <TabButton
            selected={props.selected === DiseaseCategoryType.OutcomeTest}
            onClick={props.labsClicked}
          >
            Labs
          </TabButton>
          <TabButton
            selected={props.selected === DiseaseCategoryType.Imaging}
            onClick={props.imagingClicked}
          >
            Imaging
          </TabButton>
        </PlanButtons>
      )}
    </>
  );
};
